import { Text } from '@thanx/uikit/text'
import { Order } from 'api/orders'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('users.view.activity.orders.detail')

type PropsT = {
  order: Order
}

const OrderDetailsModalProviderSection: React.FC<PropsT> = ({
  order,
}: PropsT) => {
  return (
    <>
      <Text.BodyText4 className="mb-xs" tag="div" bold>
        {t('provider_order_uid')}
      </Text.BodyText4>
      <Text.BodyText4 tag="div">{order.provider_order_uid}</Text.BodyText4>
    </>
  )
}

export default OrderDetailsModalProviderSection
